/* Mikaya — cinematic layer (home + about). Grain, cursor glow, char reveals,
   3D tilt, momentum drift, pinned word-scrub. No deps. Reduced-motion = off. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    // ---- Film grain ----
    if (!reduce && desktop) {
      var g = document.createElement('div');
      g.className = 'mkx-grain'; g.setAttribute('aria-hidden', 'true');
      document.body.appendChild(g);
    }

    // ---- Trailing cursor glow (lerp) ----
    if (!reduce && desktop && fine) {
      var glow = document.createElement('div');
      glow.className = 'mkx-glow'; glow.setAttribute('aria-hidden', 'true');
      document.body.appendChild(glow);
      var gx = -500, gy = -500, tx = gx, ty = gy, on = false;
      window.addEventListener('pointermove', function (e) {
        tx = e.clientX; ty = e.clientY;
        if (!on) { on = true; glow.classList.add('is-on'); }
      }, { passive: true });
      (function loop() {
        gx += (tx - gx) * 0.09; gy += (ty - gy) * 0.09;
        glow.style.transform = 'translate(' + gx.toFixed(1) + 'px,' + gy.toFixed(1) + 'px)';
        requestAnimationFrame(loop);
      })();
    }

    // ---- Character-level headline reveals ----
    var charTargets = document.querySelectorAll('.mk-about__hero h1, .mk-about__h1');
    var ci = 0;
    charTargets.forEach(function (el) {
      if (el.dataset.mkxChars || el.children.length > 1) return;
      var text = el.textContent;
      if (!text || text.length > 90) return;
      el.dataset.mkxChars = '1';
      el.classList.add('mkx-chars');
      el.setAttribute('aria-label', text.trim());
      var frag = document.createDocumentFragment(), i = 0;
      text.split('').forEach(function (c) {
        var s = document.createElement('span');
        s.className = 'mkx-ch'; s.textContent = c; s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--i', i++);
        frag.appendChild(s);
      });
      el.textContent = ''; el.appendChild(frag);
    });
    if (charTargets.length) {
      if (reduce || !('IntersectionObserver' in window)) {
        charTargets.forEach(function (el) { el.classList.add('is-in'); });
      } else {
        var cio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); cio.unobserve(e.target); } });
        }, { threshold: 0.4 });
        charTargets.forEach(function (el) { cio.observe(el); });
      }
    }

    // ---- Momentum parallax drift (lerped, counter-motion) ----
    if (!reduce && desktop) {
      var drifts = [];
      document.querySelectorAll('.mk-hero__content, .mk-founder__media').forEach(function (el, i) {
        el.classList.add('mkx-drift');
        drifts.push({ el: el, k: i % 2 ? 0.05 : -0.045, y: 0 });
      });
      if (drifts.length) {
        (function dloop() {
          var sy = window.scrollY || 0;
          drifts.forEach(function (d) {
            var r = d.el.getBoundingClientRect();
            var mid = r.top + r.height / 2 - window.innerHeight / 2;
            var target = mid * d.k * -1;
            d.y += (target - d.y) * 0.08;
            d.el.style.transform = 'translateY(' + d.y.toFixed(1) + 'px)';
          });
          requestAnimationFrame(dloop);
        })();
      }
    }

    // ---- Pinned cinematic chapter: home brand story ----
    var story = document.querySelector('.mk-story');
    if (story && !reduce && desktop) {
      var shost = story.closest('.shopify-section') || story;
      var cwrap = document.createElement('div');
      cwrap.className = 'mkx-chapwrap';
      shost.parentNode.insertBefore(cwrap, shost);
      cwrap.appendChild(shost);
      shost.classList.add('mkx-chap');
      cwrap.style.minHeight = '230vh';
      var pillars = story.querySelectorAll('.mk-story__pillars li');
      var lastN = -1;
      function chap() {
        var r = cwrap.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = Math.min(1, Math.max(0, -r.top / (total || 1)));
        shost.style.setProperty('--p', p.toFixed(3));
        if (pillars.length) {
          var n = Math.floor(p * 1.6 * pillars.length);
          if (n !== lastN) {
            for (var i = 0; i < pillars.length; i++) pillars[i].classList.toggle('is-lit', i < n);
            lastN = n;
          }
        }
      }
      window.addEventListener('scroll', chap, { passive: true });
      chap();
    }

    // ---- Scroll-velocity skew on product scrollers ----
    // disabled 2026-07-06: skewY made product rows visibly tilt while scrolling
    if (false && !reduce && desktop) {
      var tracks = document.querySelectorAll('.mk-scroller__track');
      if (tracks.length) {
        tracks.forEach(function (t) { t.classList.add('mkx-skew'); });
        var lastY = window.scrollY, vel = 0;
        (function sloop() {
          var y = window.scrollY;
          var target = Math.max(-1.4, Math.min(1.4, (y - lastY) * 0.05));
          lastY = y;
          vel += (target - vel) * 0.12;
          if (Math.abs(vel) > 0.01) {
            tracks.forEach(function (t) { t.style.transform = 'skewY(' + vel.toFixed(3) + 'deg)'; });
          }
          requestAnimationFrame(sloop);
        })();
      }
    }
  });
})();
